import { JobCard } from "@/components";

const JobList = () => {
  const jobs = [
    {
      title: "Sr Backend developer",
      company: "Omni group",
      location: "Remote",
      salary: "$1500 - $3000/month",
    },
    {
      title: "Frontend Engineer",
      company: "NovaStack Digital",
      location: "Hybrid",
      salary: "$2200 - $3700/month",
    },
    {
      title: "UI/UX Designer",
      company: "PixelMint Studio",
      location: "Lagos, Nigeria",
      salary: "$1800 - $3000/month",
    },
    {
      title: "DevOps Engineer",
      company: "CloudPeak Systems",
      location: "Remote",
      salary: "$4000 - $5800/month",
    },
    {
      title: "Mobile Developer",
      company: "BlueOrbit Tech",
      location: "Abuja, Nigeria",
      salary: "$2500 - $4200/month",
    },
    {
      title: "Data Analyst",
      company: "CoreVista Analytics",
      location: "Remote",
      salary: "$1700 - $2900/month",
    },
  ];

  return (
    <section className="bg-background dark:bg-background py-12 max-w-screen-2xl mx-auto lg:px-28 px-6">
      {/* Header */}
      <div className="mb-6" data-aos="fade-up" data-aos-delay="100">
        <h2 className="text-lg font-semibold text-foreground-950 dark:text-foreground-950">
          Latest opportunities
        </h2>
        <p className="text-sm text-foreground-600 dark:text-foreground-600">
          Find your next career opportunity with confidence.
        </p>
      </div>

      {/* Grid */}
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {jobs.map((job, index) => (
          <div key={index} data-aos="fade-up" data-aos-delay={index * 100}>
            <JobCard {...job} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default JobList;
